module.exports = __webpack_public_path__ + "img/solutions-ch2-people.7f463655.svg";